import React from "react";

const Vhwhite = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29 29"
      className={className}
      focusable="false"
      {...rest}
    >
      <path
        fillRule="evenodd"
        d="m6.9 4.1l-2.1-4.1h-5.8l2.7 5.2 2.3 4.6z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        d="m21.6 10.8h-11.4v-4.7h11.4z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        d="m13.8 17.6l-2.3-4.5-2.9 5.6 5.2 10.3 2.9-5.7z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        d="m22.8 0l-2.7 5.2-5.5 10.8 2.9 5.7 8.4-16.5 2.7-5.2z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        d="m10.6 0l-2.6 5.2-3.2 6.2 2.7 5.3 0.2 0.4 6.1-11.9 2.6-5.2z"
        fill="white"
      ></path>
    </svg>
  );
};

export default Vhwhite;
